import React from 'react'
import { useTranslation } from 'react-i18next'
import icons from '../assets/icons'

type Props = {
  onClick: () => void
}

const CloseCruise: React.FC<Props> = ({ onClick }: Props) => {
  const { t } = useTranslation()

  return (
    <div className='cruise--quit button--dark' onClick={onClick}>
      <img src={icons['arrow-right']} alt='close' className='cruise--quit--icon' />
      <div className='text text--size10 text--white'>
        {t('cruise.quit')}
      </div>
    </div>
  )
}

export default CloseCruise
